import { productsAndServicesApi } from 'api';
import { ProductServiceResponse } from 'pco-product-service-internal-consumer';

export const getAccountProductsServices = async (accountNumber: string): Promise<ProductServiceResponse> => {
  return await productsAndServicesApi.getAccountProductsAndServices({ accountNumber });
};
